module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Four Anonymous Wall Street Guys\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Four Anonymous Wall Street Guys wrote "), _c('I', [_vm._v("The Wall Street Joke Book.")])], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Ldnodg/images/9781466864467.jpg?1720280502101",
      "alt": "This image is the cover for the book Wall Street Joke Book"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Wall Street Joke Book\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("When disaster strikes, when election returns are in, when scandals break, when the ubiquitous racial and sexual tensions of our land blow their PC gasket, when the famous die, it seems the monied men of Wall Street are always the first to craft our national anxiety into a joke. The cynical, educated, three-steaks-a-week, house-in-the-Hamptons representatives of the Ayn Rand in all of us generate the jokes that get faxed nationwide. That's the myth, and this is the confirmation of it. Compiled by four anonymous Wall Streeters, here are the jokes that are sure to come in handy for any commuter, socially challenged business person, or new guy/gal at the water fountain. Slim enough to fit in your shirt pocket, "), _c('i', [_vm._v("The Wall Street Joke Book")]), _vm._v(" can be toted with you for those moments that call for a real-man's guffaw. Here's a taste of the humor that makes this country what it is, from the men who make this country what it is.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    St. Martin’s Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0